import React from 'react'
import { interpolate } from '../utils/proposalVariables'

const formatWholeCurrency = (amount) =>
  '$' + Math.round(Number(amount) || 0).toLocaleString('en-US')

// Terms as a 2-column card grid + (flavor path) an acceptance card with
// selected-plan checkboxes, signature/date rules, and a how-to-accept line.
const TermsConditions = ({ data, crmSnapshot, scopeData, variables }) => {
  const allSections = data?.sections || []
  const visibleSections = allSections.filter(s => !s.hidden)
  const flavors = scopeData?.flavors || []
  const showAcceptance = !data?.hideAcceptance && flavors.length > 0

  const validThrough = data?.pricingValidThrough
    ? `Pricing valid through ${data.pricingValidThrough}`
    : interpolate('Proposal valid for {{proposalValidDays}} days', variables)

  const contactBits = [crmSnapshot?.yourEmail, crmSnapshot?.yourPhone].filter(Boolean).join(' · ')

  return (
    <div className="proposal-section">
      <div className="proposal-section__headline">
        {data?.headline || (showAcceptance ? 'Terms & Acceptance' : 'Terms & Conditions')}
      </div>
      <div className="proposal-section__accent-line" />

      <div className="proposal-terms__grid">
        {visibleSections.map((section, idx) => (
          <div className="proposal-terms__card" key={idx}>
            {section.title && (
              <div className="proposal-terms__card-title">{section.title}</div>
            )}
            {section.content && (
              <div className="proposal-terms__card-content">{interpolate(section.content, variables)}</div>
            )}
          </div>
        ))}
      </div>

      {showAcceptance && (
        <div className="proposal-accept">
          <div className="proposal-accept__header">
            <span className="proposal-accept__header-title">Accept this proposal</span>
            <span className="proposal-accept__header-valid">{validThrough}</span>
          </div>
          <div className="proposal-accept__body">
            <div className="proposal-accept__plans">
              {flavors.length === 1 ? (
                /* Single tier: no selection to make — state the price plainly,
                   no Basic/Standard/Premium label */
                <>
                  <div className="proposal-accept__plans-label">Monthly fee:</div>
                  <span className="proposal-accept__plan-name is-rec">
                    {formatWholeCurrency(flavors[0].monthly)}/mo
                  </span>
                </>
              ) : (
                <>
                  <div className="proposal-accept__plans-label">Selected plan:</div>
                  {/* Boxes stay empty — the customer marks their selection */}
                  {flavors.map((flavor) => (
                    <div className="proposal-accept__plan" key={flavor.id}>
                      <span className="scope-tier__checkbox" />
                      <span className={'proposal-accept__plan-name' + (flavor.recommended ? ' is-rec' : '')}>
                        {flavor.name} &middot; {formatWholeCurrency(flavor.monthly)}/mo
                      </span>
                    </div>
                  ))}
                </>
              )}
            </div>
            <div className="proposal-accept__sig-row">
              <div className="proposal-accept__sig proposal-accept__sig--sig">
                <div className="proposal-accept__sig-line" />
                <div className="proposal-accept__sig-label">
                  Authorized signature
                </div>
              </div>
              <div className="proposal-accept__sig proposal-accept__sig--name">
                <div className="proposal-accept__sig-line" />
                <div className="proposal-accept__sig-label">Printed name</div>
              </div>
              <div className="proposal-accept__sig proposal-accept__sig--date">
                <div className="proposal-accept__sig-line" />
                <div className="proposal-accept__sig-label">Date</div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showAcceptance && (crmSnapshot?.yourName || contactBits) && (
        <div className="proposal-accept__howto">
          Questions? Contact{' '}
          {crmSnapshot?.yourName && <span className="proposal-accept__howto-name">{crmSnapshot.yourName}</span>}
          {contactBits ? ` · ${contactBits}` : ''}. To accept, sign above and return a copy — we&rsquo;ll
          confirm your start date within one business day.
        </div>
      )}
    </div>
  )
}

export default TermsConditions
